// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Webhooks_pageContent__kvHOG","header":"Webhooks_header__seT2W","headerTitle":"Webhooks_headerTitle__EzjkR","tabContent":"Webhooks_tabContent___jYqp"};